<template>
  <div class="mt-4">
    <div class="footer">
      <ul
        class="footermenu mb-0"
        v-if="currentStoreDoc && (currentStoreDoc.Policies || currentStoreDoc.TermsAndConditions)"
      >
        <li v-if="currentStoreDoc.TermsAndConditions">
          <a
            href="#"
            @click.prevent="setContent(null,currentStoreDoc.TermsAndConditions)"
          >{{ $t("message.termsAndConditions") }}</a>
        </li>
        <li v-if="currentStoreDoc.Policies && currentStoreDoc.Policies.PolicyTypePrivacy">
          <a href="#" @click.prevent="setContent(0)">{{ $t('message.privacyPolicy') }}</a>
        </li>
        <li v-if="currentStoreDoc.Policies && currentStoreDoc.Policies.PolicyTypeDelivery">
          <a href="#" @click.prevent="setContent(1)">{{ $t('message.deliveryPolicy') }}</a>
        </li>
        <li v-if="currentStoreDoc.Policies && currentStoreDoc.Policies.PolicyTypeRefund">
          <a href="#" @click.prevent="setContent(2)">{{ $t('message.refundPolicy') }}</a>
        </li>
      </ul>
    </div>
    <modal v-if="showModal" full-header @close="closeModal">
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">{{ partTitle }}</h2>
          </div>
          <p class="py-4" v-html="partContent"></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index:2">
          <button
            class="privacy-btn pull-right"
            :style="buttonStyles"
            data-dismiss="modal"
          >
            {{ $t('message.ok') }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
  </div>
</template>

<script>
import modal from "./../modal";
import { mapGetters } from "vuex";
export default {
  name: "PageFooter",
  components: {
    modal
  },
  data() {
    return {
      partContent: "",
      partTitle: "",
      showModal: false
    };
  },
  computed: {
    ...mapGetters([
      "currentStoreDoc",
      "buttonStyles",
    ]),
  },
  methods: {
    setContent(part, partContent) {
      if (part) {
        if (this.currentStoreDoc && this.currentStoreDoc.Policies) {
          switch (part) {
            case 0:
              this.partContent = this.currentStoreDoc.Policies[
                "PolicyTypePrivacy"
              ];
              this.partTitle = this.$t("message.privacyPolicy");
              break;
            case 1:
              this.partContent = this.currentStoreDoc.Policies[
                "PolicyTypeDelivery"
              ];
              this.partTitle = this.$t("message.deliveryPolicy");
              break;
            case 2:
              this.partContent = this.currentStoreDoc.Policies[
                "PolicyTypeRefund"
              ];
              this.partTitle = this.$t("message.refundPolicy");
              break;
          }
          if (this.partContent) this.showModal = true;
        }
      } else {
        this.partContent = partContent;
        this.partTitle = this.$t("message.termsAndConditions");
        if (this.partContent) this.showModal = true;
      }
    },
    closeModal() {
      this.showModal = false;
    }
  }
};
</script>
